// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604201214/js/" + chunkId + "." + {"44":"ea341846","225":"720d8dc3","481":"7f9280f4","486":"8d97b011","770":"15b3f505"}[chunkId] + ".0.35955946886957113.chunk.js";
};